(() => {
  'use strict';
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const scope = document.querySelector('main');
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) entry.target.classList.toggle('br18-offscreen', !entry.isIntersecting);
  }, {rootMargin: '100px'}) : null;
  if (scope && observer) scope.querySelectorAll('.shopify-section').forEach(section => observer.observe(section));
  document.addEventListener('visibilitychange', () => document.documentElement.classList.toggle('br18-background', document.hidden));
  document.addEventListener('shopify:section:load', event => observer?.observe(event.target));
  const query = new URLSearchParams(location.search).get('q') || '';
  document.querySelectorAll('.br-v17-filter form').forEach(form => {
    for (const [key, selector] of [['voltage','[data-br18-voltage]'],['capacity','[data-br18-capacity]'],['count','[data-br19-pack]']]) {
      const select = form.querySelector(selector);
      if (!select) continue;
      const selected = [...select.options].find(option => option.value && query.includes(JSON.stringify(option.value)));
      if (selected) { select.value = selected.value; form.closest('details').open = true; }
    }
  });
  const purchase = document.querySelector('[data-br18-purchase]');
  const product = document.querySelector('product-info[id^="MainProduct-"]');
  if (!purchase || !product) return;
  const mobile = matchMedia('(max-width: 749px)');
  let frame = 0;
  function render() {
    frame = 0;
    const button = product.querySelector('.product-form__submit');
    const panel = product.querySelector('[data-br-quantity-price]');
    const price = panel?.querySelector('.br-quantity-price__total');
    const bounds = button?.getBoundingClientRect();
    const dialogOpen = !!document.querySelector('cart-drawer.active, details[open] .menu-drawer, dialog[open], .product-media-modal[open], #shopify-pc__banner');
    const show = mobile.matches && !!bounds && bounds.bottom < 0 && !button.disabled && !dialogOpen && price && !panel.hidden;
    purchase.hidden = !show;
    if (!show) return;
    const label = panel.querySelector('.br-quantity-price__label')?.textContent || '';
    const labelNode = purchase.querySelector('[data-br18-purchase-label]');
    const priceNode = purchase.querySelector('[data-br18-purchase-price]');
    if (labelNode.textContent !== label) labelNode.textContent = label;
    if (priceNode.textContent !== price.textContent) priceNode.textContent = price.textContent;
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(render); }
  purchase.querySelector('button').addEventListener('click', () => {
    const button = product.querySelector('.product-form__submit');
    button?.scrollIntoView({block:'center',behavior:motion.matches?'instant':'smooth'});
    button?.focus({preventScroll:true});
  });
  new MutationObserver(schedule).observe(product,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','hidden']});
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(schedule).observe(drawer,{attributes:true,attributeFilter:['class']});
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  mobile.addEventListener('change',schedule);
  document.addEventListener('visitorConsentCollected',schedule);
  schedule();
})();
